// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"235":"cec6daab","237":"705ea3f6","299":"19002b7b","790":"90fae1e7"}[chunkId] + ".css";
};